import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventoryProgressBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateProgressBar);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateProgressBar);
  }

  updateProgressBar = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBlock = event.detail.data.html.querySelector('product-inventory-progress-bar');

    if (!newBlock) return;

    morph(this, newBlock, { childrenOnly: true });

    if (newBlock.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('product-inventory-progress-bar')) {
  customElements.define('product-inventory-progress-bar', ProductInventoryProgressBar);
}
